import React, { useEffect } from "react";

export default function License() {
    useEffect(() => {
        window?.anj_6d0af6aa_f683_4699_904e_956bb6b71514?.init();
    }, []);

    return <div id="anj-6d0af6aa-f683-4699-904e-956bb6b71514" data-anj-seal-id="6d0af6aa-f683-4699-904e-956bb6b71514" data-anj-image-size="128" data-anj-image-type="basic-small" style={{maxWidth: "60px"}}></div>
};